import { AxiosPromise } from 'axios';

import { ISearch } from '~/components/Pagination/Search';
import { IPagination, IPackage } from '~/models/Common';
import {
  IProfessional,
  IProfessionalForm,
  IUser,
  IUserCadasterRequiredForm,
} from '~/models/User';

import api from './api';

const ProfessionalService = {
  getAllUsers(data?: ISearch): AxiosPromise<IPagination<IUser[]>> {
    return api.get('users/professional/all', { params: data });
  },

  getOneUser(userId: string): AxiosPromise<IUser> {
    return api.get(`users/${userId}`);
  },

  editUser(userId: string, data: IUserCadasterRequiredForm): AxiosPromise {
    return api.put(`users/${userId}`, data);
  },

  createUser(data: IUserCadasterRequiredForm): AxiosPromise {
    return api.post('users', data);
  },

  createProfessional(data: IProfessionalForm): AxiosPromise<IProfessional> {
    return api.post('/auth/admin/signup/professional', data);
  },

  deleteUser(userId: string): AxiosPromise {
    return api.delete(`users/${userId}`);
  },

  updateUser(
    userId: string,
    professionalId: number,
    status: boolean,
  ): AxiosPromise {
    return api.put(`/gyms/${userId}/professionals/${professionalId}`, {
      status,
    });
  },

  getUserPackages(
    userId: string,
    data: ISearch,
  ): AxiosPromise<IPagination<IPackage[]>> {
    return api.get(`packages/professional/${userId}/all`, {
      params: data,
    });
  },

  getProfessionalStudents(
    professionalId: number,
    page: number,
    perpage = 9,
    search?: string,
    planStatus?: string,
    paymentStatus?: string,
    startDate?: string,
  ): AxiosPromise<IPagination<IUser[]>> {
    return api.get(`/admin/professional/${professionalId}/student`, {
      params: { page, perpage, search, planStatus, paymentStatus, startDate },
    });
  },

  editUserPackage(packageId: string, data: IPackage): AxiosPromise {
    return api.put(`packages/${packageId}`, data);
  },

  deleteUserPackage(packageId: string): AxiosPromise {
    return api.delete(`packages/${packageId}`);
  },
};

export default ProfessionalService;
